

import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Footer() {





  const currentYear = new Date().getFullYear();

  const location = useLocation(); // Access the current location (route)

  // useEffect hook to scroll to top when route changes
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to the top of the page
  }, [location]);

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>  <img src="/img/volletweb.svg" alt="" className="logo" /></h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Shams Business Center, Sharjah Media City Free Zone, Al Messaned,
              Sharjah, UAE.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-semibold mb-4">Legal</h4>
            <div className="space-y-2">
              <Link to="/privacy" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer block">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer block">
                Terms of Service
              </Link>
              <a href="mailto:support@vollet.io" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer block">
                Support
              </a>
            </div>
          </div>

          {/* Social */}
          <div>
            <h4 className="font-semibold mb-4">Connect</h4>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-gray-700 rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Twitter">
                <i className="ri-twitter-x-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-gray-700 rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Telegram">
                <i className="ri-telegram-line text-xl"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 hover:bg-gray-700 rounded-full flex items-center justify-center transition-colors cursor-pointer" aria-label="Discord">
                <i className="ri-discord-line text-xl"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {currentYear} Vollet. All rights reserved.
          </p>
          <a
            href=""
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer"
          >
            Powered by Vollet.io
          </a>
        </div>
      </div>
    </footer>
  );
}
